<template>
  <div>
    <el-form
      :model="parkpassruleAddFrom"
      :disabled="disabled"
      status-icon="true"
      :rules="formRules"
      ref="ruleForm"
      label-suffix=" :"
      label-width="100px"
    >
      <el-row :gutter="30">
        <el-col span="11">
          <el-form-item
            label="规则名称"
            prop="ruleName"
            :rules="[
              { required: true, message: '请输入规则名称', trigger: 'blur' },
              { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="parkpassruleAddFrom.ruleName"
              placeholder="请输入规则名称3-16位"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="11">
          <el-form-item
            label="停车场"
            prop="parkingLotId"
            :rules="[{ required: true, message: '请选择车场名称', trigger: 'blur' }]"
          >
            <el-select
              v-model="parkpassruleAddFrom.parkingLotId"
              :disabled="edit"
              @change="changeType"
              placeholder="请选择停车场"
            >
              <el-option
                v-for="item in parkList"
                :key="item.value"
                :label="item.title"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col span="11">
          <el-form-item
            label="规则编号"
            prop="ruleCode"
            :rules="[
              { required: true, message: '请输入规则编号', trigger: 'blur' },
              { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="parkpassruleAddFrom.ruleCode"
              :disabled="edit"
              placeholder="请输入规则编号3-16位"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="11">
          <el-form-item
            label="出入类型"
            prop="passageType"
            :rules="[{ required: true, message: '请选择出入类型', trigger: 'blur' }]"
          >
            <el-select
              v-model="parkpassruleAddFrom.passageType"
              :disabled="edit"
              @change="$forceUpdate()"
              placeholder="请选择出入类型"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="11">
          <el-form-item
            label="描述"
            prop="remark"
            :rules="[{ min: 3, max: 8, message: '长度在 3 到 8 个字符', trigger: 'blur' }]"
          >
            <el-input v-model="parkpassruleAddFrom.remark" placeholder="请输入规则描述"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="in">
          <span slot="label">临时车</span>
          <div v-if="parkpassruleAddFrom.passageType == 1">
            <el-row>
              <el-form-item label="正常入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="tempCarRule.settingRules.normalPass.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="tempCarRule.settingRules.normalPass.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车位已满允许自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="tempCarRule.settingRules.parkSpaceFull.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="tempCarRule.settingRules.parkSpaceFull.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车辆重复允许自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="tempCarRule.settingRules.vehicleDuplicated.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="tempCarRule.settingRules.vehicleDuplicated.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="军警车自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="tempCarRule.settingRules.policeCarAutoPass.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="tempCarRule.settingRules.policeCarAutoPass.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="业主临时车宽进" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="tempCarRule.settingRules.useHouseholdTempcar.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input
                    v-model="tempCarRule.settingRules.useHouseholdTempcar.remark"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
          </div>
          <div v-show="parkpassruleAddFrom.passageType == 2">
            <div>
              <el-row>
                <el-form-item label="正常出场" label-width="205px" prop="name">
                  <el-col span="5">
                    <el-select
                      v-model="tempCarRuleOut.settingRules.normalPass.statusType"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options3"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="line" span="14">
                    <el-input v-model="tempCarRuleOut.settingRules.normalPass.remark"></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="无入场记录允许自动出场" label-width="205px" prop="name">
                  <el-col span="5">
                    <el-select
                      v-model="tempCarRuleOut.settingRules.withoutInRecord.statusType"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options3"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="line" span="14">
                    <el-input
                      v-model="tempCarRuleOut.settingRules.withoutInRecord.remark"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="按最近入场记录匹配" label-width="205px" prop="name">
                  <el-col span="5">
                    <el-select
                      v-model="tempCarRuleOut.settingRules.matchByLastIn.statusType"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="line" span="14">
                    <el-input v-model="tempCarRuleOut.settingRules.matchByLastIn.remark"></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="军管车自动出场" label-width="205px" prop="name">
                  <el-col span="5">
                    <el-select
                      v-model="tempCarRuleOut.settingRules.policeCarAutoPass.statusType"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options3"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="line" span="14">
                    <el-input
                      v-model="tempCarRuleOut.settingRules.policeCarAutoPass.remark"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="收费0元自动开闸" label-width="205px" prop="name">
                  <el-col span="5">
                    <el-select
                      v-model="tempCarRuleOut.settingRules.autoOpenWithoutPay.statusType"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options3"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="line" span="14">
                    <el-input
                      v-model="tempCarRuleOut.settingRules.autoOpenWithoutPay.remark"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="无法识别车辆按最低标准收费" label-width="205px" prop="name">
                  <el-col span="5">
                    <el-select
                      v-model="tempCarRuleOut.settingRules.lowerBarWhenUnrecognized.statusType"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="line" span="14">
                    <el-input
                      v-model="tempCarRuleOut.settingRules.lowerBarWhenUnrecognized.remark"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
            </div>
          </div>
          <el-row style="text-align: center" v-show="disabled == false">
            <el-form-item style="text-align: center">
              <el-button type="primary" @click="onSubmit">提 交</el-button>
            </el-form-item>
          </el-row>
        </el-tab-pane>
        <el-tab-pane name="out">
          <span slot="label">月卡车</span>
          <!-- 临时车 -->
          <div v-if="parkpassruleAddFrom.passageType == 1">
            <el-row>
              <el-form-item label="正常入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRule.settingRules.normalPass.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRule.settingRules.normalPass.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车位已满允许自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRule.settingRules.parkSpaceFull.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRule.settingRules.parkSpaceFull.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车辆重复允许自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRule.settingRules.vehicleDuplicated.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRule.settingRules.vehicleDuplicated.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车位被占用允许自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRule.settingRules.parkSpaceUsed.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRule.settingRules.parkSpaceUsed.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <div style="font-weight: bold; margin-bottom: 20px">车辆过期允许入场</div>
            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 10px" :gutter="40">
              <el-col span="10">
                <div style="padding-left: 25px">权限1</div>
                <div>
                  <el-form-item label="天数" prop="carPermissions1">
                    <el-input
                      style="width: 100%"
                      v-model="carExpiredRules[0].dayCount"
                      @input="(e) => permissions(e, 'carPermissions1')"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="carExpiredRules[0].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input style="width: 100%" v-model="carExpiredRules[0].remark"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col span="10">
                <div style="padding-left: 25px">权限2</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input style="width: 100%" v-model="carExpiredRules[1].dayCount"></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="carExpiredRules[1].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input style="width: 100%" v-model="carExpiredRules[1].remark"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="40" style="border-bottom: 2px solid #eee; margin-bottom: 10px">
              <el-col span="10">
                <div style="padding-left: 25px">权限3</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input style="width: 100%" v-model="carExpiredRules[2].dayCount"></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="carExpiredRules[2].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input style="width: 100%" v-model="carExpiredRules[2].remark"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <div style="font-weight: bold; margin-bottom: 20px">车位过期允许入场</div>
            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 10px" :gutter="40">
              <el-col span="10">
                <div style="padding-left: 25px">权限1</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="spaceExpiredRules[0].dayCount"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="spaceExpiredRules[0].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input style="width: 100%" v-model="spaceExpiredRules[0].remark"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col span="10">
                <div style="padding-left: 25px">权限2</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="spaceExpiredRules[1].dayCount"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="spaceExpiredRules[1].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input style="width: 100%" v-model="spaceExpiredRules[1].remark"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 10px" :gutter="40">
              <el-col span="10">
                <div style="padding-left: 25px">权限3</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="spaceExpiredRules[2].dayCount"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="spaceExpiredRules[2].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input style="width: 100%" v-model="spaceExpiredRules[2].remark"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 月卡车 -->
          <div v-show="parkpassruleAddFrom.passageType == 2">
            <el-row>
              <el-form-item label="正常出场" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.normalPass.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRuleOut.settingRules.normalPass.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="无入场记录自动出场" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.withoutInRecord.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input
                    v-model="monthCarRuleOut.settingRules.withoutInRecord.remark"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车位被占需缴费" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.parkSpaceUsedPay.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input
                    v-model="monthCarRuleOut.settingRules.parkSpaceUsedPay.remark"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车位过期允许按临时车缴费" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.parkSpaceExpiredToTemp.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input
                    v-model="monthCarRuleOut.settingRules.parkSpaceExpiredToTemp.remark"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车辆过期允许按临时车缴费" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.vehicleExpiredToTemp.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input
                    v-model="monthCarRuleOut.settingRules.vehicleExpiredToTemp.remark"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="按最近入场纪录匹配" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.matchByLastIn.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRuleOut.settingRules.matchByLastIn.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <div style="font-weight: bold; margin-bottom: 20px">车辆过期允许出场</div>
            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 10px" :gutter="40">
              <el-col span="10">
                <div style="padding-left: 25px">权限1</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="carExpiredRulesOut[0].dayCount"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="carExpiredRulesOut[0].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input style="width: 100%" v-model="carExpiredRulesOut[0].remark"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col span="10">
                <div style="padding-left: 25px">权限2</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="carExpiredRulesOut[1].dayCount"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="carExpiredRulesOut[1].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input style="width: 100%" v-model="carExpiredRulesOut[1].remark"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 10px" :gutter="40">
              <el-col span="10">
                <div style="padding-left: 25px">权限3</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="carExpiredRulesOut[2].dayCount"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="carExpiredRulesOut[2].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input style="width: 100%" v-model="carExpiredRulesOut[2].remark"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <div style="font-weight: bold; margin-bottom: 20px">车位过期允许出场</div>
            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 10px" :gutter="40">
              <el-col span="10">
                <div style="padding-left: 25px">权限1</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="spaceExpiredRulesOut[0].dayCount"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="spaceExpiredRulesOut[0].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="spaceExpiredRulesOut[0].remark"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col span="10">
                <div style="padding-left: 25px">权限2</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="spaceExpiredRulesOut[1].dayCount"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="spaceExpiredRulesOut[1].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="spaceExpiredRulesOut[1].remark"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 10px" :gutter="40">
              <el-col span="10">
                <div style="padding-left: 25px">权限3</div>
                <div>
                  <el-form-item label="天数" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="spaceExpiredRulesOut[2].dayCount"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="权限控制" prop="name">
                    <el-select v-model="spaceExpiredRulesOut[2].statusType" placeholder="请选择">
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="提示信息" prop="name">
                    <el-input
                      style="width: 100%"
                      v-model="spaceExpiredRulesOut[2].remark"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-row style="text-align: center" v-show="disabled == false">
            <el-form-item style="text-align: center">
              <el-button type="primary" @click="onSubmit">提 交</el-button>
            </el-form-item>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import request from '@/util/request';
export default {
  name: 'parkpassrule-form',
  props: ['parkpassruleAddFrom', 'disabled', 'edit'],
  data() {
    return {
      activeName: 'in',
      showType: 1,
      type: '月卡车',

      tempCarRule: {
        //临时车规则 入场
        setmealType: 1,
        settingRules: {
          normalPass: {
            remark: '',
            statusType: 1,
          },
          parkSpaceFull: {
            remark: '车位已满，禁止通行',
            statusType: 4,
          },
          policeCarAutoPass: {
            remark: '',
            statusType: 1,
          },
          vehicleDuplicated: {
            remark: '',
            statusType: 1,
          },
          useHouseholdTempcar: {
            remark: '',
            statusType: 4,
          },
        },
      },
      monthCarRule: {
        //月卡车规则 入场
        setmealType: 1,
        settingRules: {
          normalPass: {
            remark: '',
            statusType: 1,
          },
          parkSpaceFull: {
            remark: '车位已满，禁止通行',
            statusType: 1,
          },
          parkSpaceUsed: {
            remark: '',
            statusType: 1,
          },
          vehicleDuplicated: {
            remark: '',
            statusType: 1,
          },
        },
      },
      spaceExpiredRules: [
        {
          //车位规则 入场
          remark: '',
          dayCount: 20,
          statusType: 1,
        },
        {
          remark: '',
          dayCount: 0,
          statusType: 1,
        },
        {
          remark: '',
          dayCount: -1,
          statusType: 4,
        },
      ],
      carExpiredRules: [
        {
          //车辆规则 入场
          remark: '月卡车,剩余TT天,请尽快延期',
          dayCount: 20,
          statusType: 1,
        },
        {
          remark: '月卡车,已过期，请尽快延期',
          dayCount: 0,
          statusType: 1,
        },
        {
          remark: '月卡车,已过期，禁止通行',
          dayCount: -1,
          statusType: 4,
        },
      ],
      // 出场
      tempCarRuleOut: {
        //临时车规则 出场
        setmealType: 4,
        settingRules: {
          normalPass: {
            remark: '',
            statusType: 1,
          },
          matchByLastIn: {
            remark: '',
            statusType: 4,
          },
          withoutInRecord: {
            remark: '',
            statusType: 1,
          },
          policeCarAutoPass: {
            remark: '',
            statusType: 1,
          },
          autoOpenWithoutPay: {
            remark: '',
            statusType: 1,
          },
          lowerBarWhenUnrecognized: {
            remark: '',
            statusType: 4,
          },
        },
      },
      monthCarRuleOut: {
        //月卡车规则 出场
        setmealType: 4,
        settingRules: {
          normalPass: {
            remark: '',
            statusType: 1,
          },
          matchByLastIn: {
            remark: '',
            statusType: 1,
          },
          withoutInRecord: {
            remark: '',
            statusType: 1,
          },
          parkSpaceUsedPay: {
            remark: '',
            statusType: 5,
          },
          vehicleExpiredToTemp: {
            remark: '',
            statusType: 5,
          },
          parkSpaceExpiredToTemp: {
            remark: '',
            statusType: 5,
          },
        },
      },
      spaceExpiredRulesOut: [
        {
          //车位规则 出场
          remark: '',
          dayCount: 20,
          statusType: 1,
        },
        {
          remark: '',
          dayCount: 0,
          statusType: 1,
        },
        {
          remark: '',
          dayCount: -2,
          statusType: 4,
        },
      ],
      carExpiredRulesOut: [
        {
          //车辆规则 出场
          remark: '月卡车,剩余TT天,请尽快延期',
          dayCount: 20,
          statusType: 1,
        },
        {
          remark: '月卡车,已过期,请尽快延期',
          dayCount: 0,
          statusType: 1,
        },
        {
          remark: '月卡车,已过期,通行',
          dayCount: -1,
          statusType: 4,
        },
      ],
      options: [
        { label: '出口规则', value: 2 },
        { label: '入口规则', value: 1 },
      ],
      options3: [
        { label: '允许', value: 1 },
        { label: '确认', value: 2 },
        { label: '禁止', value: 4 },
      ],
      options4: [
        { label: '允许', value: 1 },
        { label: '确认', value: 2 },
        { label: '警告', value: 3 },
        { label: '禁止', value: 4 },
      ],
      options2: [
        { label: '禁止', value: 4 },
        { label: '启用', value: 5 },
      ],
      formRules: {
        parkingLotId: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
      },
      parkList: [],
    };
  },
  created() {
    this.getParkList().then((res) => {
      this.parkList = res.data;
    });
    if (!this.parkpassruleAddFrom.passageType) {
      this.parkpassruleAddFrom.passageType == 1;
    }
  },
  methods: {
    changeType(val) {},
    input() {
      this.$forceUpdate();
    },
    permissions(e, key) {
      this.parkpassruleAddFrom[key] = e;
    },
    showData(data) {
      if (data.length !== 0) {
        let rules = JSON.parse(data.ruleData);
        if (data.passageType == 1) {
          this.tempCarRule = rules.tempCarRule;
          this.monthCarRule = rules.monthCarRule;
          this.carExpiredRules = rules.monthCarRule.carExpiredRules;
          this.spaceExpiredRules = rules.monthCarRule.spaceExpiredRules;
        } else if (this.parkpassruleAddFrom.passageType == 2) {
          this.tempCarRuleOut = rules.tempCarRule;
          this.monthCarRuleOut = rules.monthCarRule;
          this.carExpiredRulesOut = rules.monthCarRule.carExpiredRules;
          this.spaceExpiredRulesOut = rules.monthCarRule.spaceExpiredRules;
        }
      }
    },
    getParkList(params, options) {
      return request.get(
        '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
        Object.assign({}, options, { params })
      );
    },
    onSubmit(type) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 验证车辆过期允许入场权限 月卡车入场
          for (let i = 0; i < this.carExpiredRules.length; i++) {
            let reg = /^\+?[1-9][0-9]*$/;
            let reg2 = /^((-\d+)|(0+))$/;
            if (this.carExpiredRules[i].dayCount === '') {
              this.$message.error('请输入车辆过期允许入场，权限' + (i + 1));
              return;
            }
            if (
              !(
                reg.test(this.carExpiredRules[i].dayCount) ||
                reg2.test(this.carExpiredRules[i].dayCount)
              )
            ) {
              this.$message.error(
                '格式错误！请输入车辆过期允许入场,权限' + (i + 1) + '天数为数字！'
              );
              return;
            }
            reg.lastIndex = 0;
            reg2.lastIndex = 0;
          }
          // // 验证车位过期允许入场权限 月卡车入场
          for (let i = 0; i < this.spaceExpiredRules.length; i++) {
            let reg = /^\+?[1-9][0-9]*$/;
            let reg2 = /^((-\d+)|(0+))$/;
            if (this.spaceExpiredRules[i].dayCount === '') {
              this.$message.error('请输入车位过期允许入场，权限' + (i + 1));
              return;
            }
            if (
              !(
                reg.test(this.spaceExpiredRules[i].dayCount) ||
                reg2.test(this.spaceExpiredRules[i].dayCount)
              )
            ) {
              this.$message.error(
                '格式错误！请输入车位过期允许入场,权限' + (i + 1) + '天数为数字！'
              );
              return;
            }
            reg.lastIndex = 0;
            reg2.lastIndex = 0;
          }
          // 验证车辆过期允许出场权限 月卡车出场
          for (let i = 0; i < this.carExpiredRulesOut.length; i++) {
            let reg = /^\+?[1-9][0-9]*$/;
            let reg2 = /^((-\d+)|(0+))$/;
            if (this.carExpiredRulesOut[i].dayCount === '') {
              this.$message.error('请输入车辆过期允许出场，权限' + (i + 1));
              return;
            }
            if (
              !(
                reg.test(this.carExpiredRulesOut[i].dayCount) ||
                reg2.test(this.carExpiredRulesOut[i].dayCount)
              )
            ) {
              this.$message.error(
                '格式错误！请输入车辆过期允许出场,权限' + (i + 1) + '天数为数字！'
              );
              return;
            }
            reg.lastIndex = 0;
            reg2.lastIndex = 0;
          }
          // 验证车位过期允许出场权限 月卡车出场
          for (let i = 0; i < this.spaceExpiredRulesOut.length; i++) {
            let reg = /^\+?[1-9][0-9]*$/;
            let reg2 = /^((-\d+)|(0+))$/;
            if (this.spaceExpiredRulesOut[i].dayCount === '') {
              this.$message.error('请输入车位过期允许出场，权限' + (i + 1));
              return;
            }
            if (
              !(
                reg.test(this.spaceExpiredRulesOut[i].dayCount) ||
                reg2.test(this.spaceExpiredRulesOut[i].dayCount)
              )
            ) {
              this.$message.error(
                '格式错误！请输入车位过期允许出场,权限' + (i + 1) + '天数为数字！'
              );
              return;
            }
            reg.lastIndex = 0;
            reg2.lastIndex = 0;
          }
          this.inRuleForm();
          this.$emit('submit');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    inRuleForm() {
      let obj = {};
      if (this.parkpassruleAddFrom.passageType == 1) {
        obj.tempCarRule = this.tempCarRule;
        obj.monthCarRule = this.monthCarRule;
        obj.monthCarRule.carExpiredRules = this.carExpiredRules;
        obj.monthCarRule.spaceExpiredRules = this.spaceExpiredRules;
      } else if (this.parkpassruleAddFrom.passageType == 2) {
        obj.tempCarRule = this.tempCarRuleOut;
        obj.monthCarRule = this.monthCarRuleOut;
        obj.monthCarRule.carExpiredRules = this.carExpiredRulesOut;
        obj.monthCarRule.spaceExpiredRules = this.spaceExpiredRulesOut;
      }
      this.parkpassruleAddFrom.ruleData = JSON.stringify(obj);
    },
  },
};
</script>
